// extracted by mini-css-extract-plugin
export default {"dataIngestorRoutes":"dataIngestorRoutes-nQVH7","routeErrorContainer":"routeErrorContainer-gIgsP"};